<template>
  <div id="modalCreateEditProfile" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Perfil</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.profile.nome.$errors.length }"
                  placeholder="Nome do Perfil"
                  v-model="v$.profile.nome.$model"
                />
                <span
                  v-if="
                    v$.profile.nome.required.$invalid &&
                    v$.profile.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">Descrição:</label>
                <textarea
                  class="form-control"
                  placeholder="Descrição do Perfil"
                  rows="2"
                  v-model="profile.descricao"
                />
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Selecione os relatórios que os usuários com este perfil
                  poderão acessar: <span class="text-danger">*</span>
                </label>
                <div class="row">
                  <div
                    v-for="report in reports"
                    :key="report.id"
                    class="col-sm-4"
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="report.id"
                        :value="report.id"
                        v-model="companyReports"
                      />
                      <label class="form-check-label" :for="report.id">
                        {{ report.relatorioNome }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-dark"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditProfileModal',

  props: {
    profileId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      profile: {
        nome: '',
        descriacao: '',
      },
      companyReports: [],
      reports: [],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.profileId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getReportsByCompany() {
      try {
        this.reports = await this.$store.dispatch('getReportsByCompany')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getProfile() {
      try {
        const { profile, companyReports } = await this.$store.dispatch(
          'getProfile',
          this.profileId,
        )

        this.profile = profile
        this.companyReports = companyReports.map(
          (report) => report.empresaRelatorioId,
        )

        showModal('modalCreateEditProfile')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        if (this.companyReports.length === 0) {
          this.$root.$refs.notification.warning(
            'Selecione pelo menos um relatório.',
          )
          return
        }

        this.disableButton = true
        try {
          let response = null

          if (this.profileId) {
            response = await this.$store.dispatch('updateProfile', {
              id: this.profileId,
              profile: this.profile,
              companyReports: this.companyReports,
            })
          } else {
            response = await this.$store.dispatch('createProfile', {
              profile: this.profile,
              companyReports: this.companyReports,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      profile: {
        nome: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getReportsByCompany()
    if (this.profileId) {
      this.getProfile()
    } else {
      showModal('modalCreateEditProfile')
    }
  },
}
</script>
